import { render } from "./comformorder.vue?vue&type=template&id=8d766b86&scoped=true"
import script from "./comformorder.vue?vue&type=script&lang=js"
export * from "./comformorder.vue?vue&type=script&lang=js"

import "./comformorder.vue?vue&type=style&index=0&id=8d766b86&lang=scss&scoped=true"
import "./comformorder.vue?vue&type=style&index=1&id=8d766b86&lang=scss&scoped=true"

import exportComponent from "E:\\Project\\UGit\\heronlink\\web\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d766b86"]])

export default __exports__